import React from 'react';

const colorClasses = {
  blue: 'bg-primary-500',
  green: 'bg-success-500',
  red: 'bg-red-500',
  yellow: 'bg-accent-500',
  purple: 'bg-purple-500'
};

const MetricCard = ({ title, value, icon: Icon, trend, color = 'blue' }) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <div className="flex items-start gap-3">
        <div className={`${colorClasses[color]} p-2 rounded-lg flex-shrink-0`}>
          <Icon className="w-4 h-4 text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-medium text-gray-500 truncate">{title}</p>
          <p className="text-xl font-bold text-gray-900">{value}</p>
          {trend && (
            <p className={`text-xs ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
              {trend > 0 ? '+' : ''}{trend}% from last period
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
